<template>
  <div class="table-responsive">
    <table class="table pdf-item container">
      <thead class="cabecalho">
        <tr>
          <th scope="col">Operadora</th>
          <th scope="col">Serviço</th>
          <th scope="col">Dependência</th>
          <th scope="col" class="text-center">Quantidade</th>
          <th scope="col" class="text-left text-md-right">Valor Unitário</th>
          <th scope="col" class="text-left text-md-right">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.operadora }}</td>
          <td>{{ item.servico }}</td>
          <td>{{ item.dependencia }}</td>
          <td class="text-center">{{ item.quantidade }}</td>
          <td class="text-left text-md-right">
            {{ item.vlrunitario | currency }}
          </td>
          <td class="text-left text-md-right">
            {{ item.vlrtotal | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    items: Array,
  },
  filters: {
    currency(valor) {
      if (isNaN(valor)) {
        return "-";
      } else {
        var formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return formatter.format(valor);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
th {
  color: #222;
  font-weight: 800;
  font-size: 15px;
  text-transform: uppercase;
  border: none;
}
td {
  color: #212529;
  font-weight: 500;
  font-size: 16px;
  text-transform: uppercase;
  border-color: #e9ecef;
}
.pdf-content {
  th {
    font-size: 19px;
    font-weight: 800;
    padding: 1px;
    padding-bottom: 5px;
  }
  td {
    font-size: 13px;
    font-weight: 700;
    padding: 2px;
  }
  .cabecalho {
    font-weight: 800;
    background-color: lightgray !important;
  }
  tr:nth-child(even) {
    background: #fff !important;
  }
  tbody > tr:nth-of-type(odd) {
    background: #fff !important;
  }
}
</style>
